function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_040-skills",
  "data-name": "040-skills",
  transform: "translate(0 -26.777)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31771",
  "data-name": "Path 31771",
  d: "M30.332,412.442H1.4a1.321,1.321,0,0,1-1.4-1.4v-5.172a7.934,7.934,0,0,1,4.054-6.989l11.042-6.01a1.27,1.27,0,0,1,1.4,0l11.042,6.01a7.934,7.934,0,0,1,4.054,6.989v5.172A1.217,1.217,0,0,1,30.332,412.442ZM2.8,409.647H28.934v-3.774a5.009,5.009,0,0,0-2.656-4.473l-10.483-5.731L5.311,401.4a5.009,5.009,0,0,0-2.656,4.473v3.774Z",
  transform: "translate(0 -331.658)",
  fill: "#8b8c8e"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31772",
  "data-name": "Path 31772",
  d: "M62.586,329.574c0,4.892-3.215,10.483-7.268,10.483s-7.268-5.451-7.268-10.483c0-4.892,3.215-7.408,7.268-7.408S62.586,324.682,62.586,329.574Z",
  transform: "translate(-39.523 -273.67)",
  fill: "#f0f2f6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_31773",
  "data-name": "Path 31773",
  d: "M48.838,334.976c-4.892,0-8.666-6.29-8.666-11.881,0-5.311,3.494-8.806,8.666-8.806S57.5,317.923,57.5,323.1C57.5,328.686,53.87,334.976,48.838,334.976Zm0-17.752c-3.634,0-5.871,2.236-5.871,6.01,0,4.473,2.935,9.086,5.871,9.086s5.871-4.613,5.871-9.086C54.709,319.461,52.612,317.224,48.838,317.224Z",
  transform: "translate(-33.043 -267.191)",
  fill: "#8b8c8e"
}), /*#__PURE__*/React.createElement("g", {
  id: "star",
  transform: "translate(8.545 27.278)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_31775",
  "data-name": "Path 31775",
  d: "M2.6,14.143a.482.482,0,0,0,.677.538l3.983-2.047,3.982,2.047a.481.481,0,0,0,.677-.537l-.753-4.292,3.2-3.045a.5.5,0,0,0-.257-.862L9.665,5.314,7.682,1.388a.465.465,0,0,0-.841,0L4.859,5.315.416,5.946a.5.5,0,0,0-.257.862l3.2,3.045L2.6,14.145Zm4.45-2.511L3.708,13.351l.629-3.59A.513.513,0,0,0,4.19,9.3L1.554,6.789,5.23,6.267a.476.476,0,0,0,.356-.261L7.262,2.687,8.937,6.005a.476.476,0,0,0,.356.261l3.676.522L10.334,9.3a.512.512,0,0,0-.148.459l.629,3.59L7.471,11.633a.456.456,0,0,0-.418,0Z",
  transform: "translate(-0.003 -1.122)",
  fill: "#8b8c8e",
  stroke: "#8b8c8e",
  strokeWidth: 1,
  fillRule: "evenodd"
})));

function SvgSubmitRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.608,
    height: 54.007,
    viewBox: "0 0 31.608 54.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitRating);
export default __webpack_public_path__ + "static/media/SubmitRating.edb77260.svg";
export { ForwardRef as ReactComponent };